<template>
  <div class="custom-upload">
    <a-upload
      name="file"
      accept="image/*"
      :capture="false"
      list-type="picture-card"
      class="avatar-uploader"
      :show-upload-list="false"
      :action="baseUrl"
      :headers="headers"
      :before-upload="beforeUpload"
      @change="handleChange"
    >
      <img v-if="imageUrl" :src="imageUrl" alt="avatar" />
      <div v-else>
        <a-icon :type="loading ? 'loading' : 'plus'" />
        <div class="ant-upload-text">上传头像</div>
      </div>
    </a-upload>
  </div>
</template>

<script>
import ImageCompressor from "image-compressor.js";
import EXIF from "exif-js";
export default {
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      imageUrl: "",
      headers: {
        secret:
          "6aae5ea9abd6a86df1556ff851d09ff7255670a8a5da822e446cad459d9203e4",
      },
      baseUrl: process.env.VUE_APP_API_BASE_URL + "/api/Oss/UploadAvatar",
    };
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(val) {
        if(!!val) {
          this.imageUrl = val;
        }
      }
    }
  },
  methods: {
    async beforeUpload(file) {
      const orientationImgFile = await this.adjustImageOrientation(file);
      const loading = this.$message.loading("头像压缩中，请稍后...", 0);
      return new Promise(async (resolve, reject) => {
        // 初始压缩质量为0.8
        const compressedFile = await this.compressImage(
          orientationImgFile,
          0.8
        ).catch((err) => {
          loading();
          this.$message.error("压缩失败：头像体积过大");
          reject(err);
        });
        if (!!compressedFile) {
          loading();
          this.$message.success("压缩完成");
          console.log("compressedFile", compressedFile);
          // return reject(false);
          return resolve(compressedFile);
        }
      });
    },
    // 返回处理结果
    async adjustImageOrientation(file) {
      var _that = this;
      return new Promise((resolve, reject) => {
        if (!file) {
          console.error("未读取到图像");
          return reject("未读取到图像");
        }

        EXIF.getData(file, function () {
          const orientation = EXIF.getTag(this, "Orientation");
          _that
            .readAndProcessImage(file, orientation)
            .then(resolve)
            .catch(reject);
        });
      });
    },
    readAndProcessImage(file, orientation) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = () => {
          const img = new Image();
          img.onload = () => {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            // 将预期大小设置为图片原始大小。不进行自适应尺寸
            // let expectedWidth = img.naturalWidth;
            // let expectedHeight = img.naturalHeight;

            const maxWidth = 1000; // 最大宽度
            const maxHeight = 800; // 最大高度
            const aspectRatio = img.naturalWidth / img.naturalHeight;
            let scaledWidth, scaledHeight;

            // 如果超过规定宽度以及高度，则进行等比例缩放
            if (img.naturalWidth > maxWidth || img.naturalHeight > maxHeight) {
              if (aspectRatio > 1) {
                scaledWidth = maxWidth;
                scaledHeight = maxWidth / aspectRatio;
              } else {
                scaledWidth = maxHeight * aspectRatio;
                scaledHeight = maxHeight;
              }
            } else {
              scaledWidth = img.naturalWidth;
              scaledHeight = img.naturalHeight;
            }

            canvas.width = scaledWidth;
            canvas.height = scaledHeight;
            // canvas.width = expectedWidth;
            // canvas.height = expectedHeight;
            // ctx.drawImage(img, 0, 0, expectedWidth, expectedHeight);
            ctx.drawImage(img, 0, 0, scaledWidth, scaledHeight);

            if (orientation && orientation !== 1) {
              console.log(`检测到方向: ${orientation}`);
              this.applyRotation(ctx, orientation);
            }

            canvas.toBlob(
              (blob) => {
                if (!blob) {
                  reject("未读取到图像");
                  return;
                }
                const newFile = new File([blob], file.name, {
                  type: "image/jpeg",
                  lastModified: Date.now(),
                });
                console.log(newFile, "调整后的图像文件");
                resolve(newFile);
              },
              "image/jpeg",
              0.8
            );
          };
          img.onerror = reject;
          img.src = reader.result;
        };
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
    },
    applyRotation(context, orientation) {
      switch (orientation) {
        case 6: // 需要（向左）90度旋转
          context.rotate(Math.PI / 2);
          break;
        case 8: // 需要（向右）90度旋转
          context.rotate((3 * Math.PI) / 2);
          break;
        case 3: // 需要180度旋转
          context.rotate(Math.PI);
          break;
        default:
          console.log("处理图像错误.");
      }
    },
    compressImage(file, quality, maxRecursion = 8) {
      // 添加一个最大递归次数的参数
      if (maxRecursion <= 0) {
        // 如果递归次数达到上限，则返回一个错误
        return Promise.reject(new Error("图片压缩递归次数达到上限"));
      }

      return new Promise((resolve, reject) => {
        const compressor = new ImageCompressor(file, {
          quality: quality, // 传入当前的压缩质量
          success: (blob) => {
            const currentFile = new File([blob], file.name, {
              type: blob.type,
            });
            console.log("currentQuality", quality);
            console.log(
              "currentSize",
              (currentFile.size / 1024).toFixed(2) + "KB"
            );

            // 检查文件大小是否满足要求
            if (currentFile.size <= 500 * 1024) {
              // 如果满足要求，则直接返回压缩后的文件
              resolve(currentFile);
            } else if (maxRecursion > 1) {
              // 如果不满足要求且还有递归次数，则递归调用自身，降低压缩质量
              this.compressImage(
                file,
                Math.max(0.1, quality - 0.1),
                maxRecursion - 1
              )
                .then(resolve) // 使用resolve传递结果
                .catch(reject); // 捕获递归调用中的错误并拒绝Promise
            } else {
              // 如果没有递归次数了，但仍然不满足要求，则拒绝Promise
              reject(new Error("图片大小仍然超过限制，且已达到最大递归次数"));
            }
          },
          error: (err) => {
            reject(err); // 压缩过程中发生错误，直接拒绝Promise
          },
        });
        compressor.compress(); // 开始压缩
      });
    },
    handleChange(info) {
      if (info.file.status === "uploading") {
        this.loading = true;
        return;
      }
      if (info.file.status === "done") {
        const filePath = info.file.response.data.fileUrl;
        this.loading = false;
        this.imageUrl = filePath;
        this.$emit("update:value", filePath);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.custom-upload {
  display: flex;
  align-items: center;
  justify-self: center;
  width: 100%;
}

.avatar-uploader {
  display: flex;
  justify-content: center;
  ::v-deep(.ant-upload) {
    overflow: hidden !important;
    border-radius: 50% !important;
    border-color: var(--primary-color) !important;
  }
  img {
    width: 120px;
    height: 120px;
    border-radius: 50%;
    object-fit: cover;
  }
}
</style>
